import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { updateDoc, increment } from "firebase/firestore";

const STATUS_OPTIONS = ["pending", "ready", "created"];

function safeStr(v) {
  return (v ?? "").toString();
}

export async function notifySongUpdate(uid) {
  const ref = doc(db, "usuarios", uid, "notifs", "summary");
  await setDoc(
    ref,
    {
      songUpdates: increment(1),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}


export default function CrearCancionDesdeUsuario() {
  const { usuarioId } = useParams();
  const navigate = useNavigate();

  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  // form
  const [titulo, setTitulo] = useState("");
  const [letra, setLetra] = useState("");
  const [estilo, setEstilo] = useState("");
  const [prompt, setPrompt] = useState("");

  const [status, setStatus] = useState("pending");
  const [pago, setPago] = useState(false);
  const [nombreCliente, setNombreCliente] = useState("");

  const uid = safeStr(usuarioId).trim();

  const disabledCreate = useMemo(() => !uid || saving, [uid, saving]);

  const handleCreate = async () => {
    if (!uid) {
      setMsg("Falta usuarioId en la URL.");
      return;
    }

    try {
      setSaving(true);
      setMsg("");

      // ✅ Crear nuevo docId
      const cancionesCol = collection(db, "usuarios", uid, "canciones");
      const docRef = doc(cancionesCol); // genera id

      const songId = docRef.id;

      // ====== 1) Guardar cancion (usuario) ======
      const data = {
        // 👇 aquí ya no dependes de un campo id manual
        id: songId,
        usuarioId: uid,

        titulo: safeStr(titulo).trim(),
        letra: safeStr(letra),
        estilo: safeStr(estilo).trim(),
        prompt: safeStr(prompt),

        pago: !!pago,
        status: STATUS_OPTIONS.includes(status) ? status : "pending",
        fechaCreacion: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      await setDoc(docRef, data, { merge: true });

      // ====== 2) Mini doc para compartir ======
      const miniRef = doc(db, "cancionesWeb", songId);

      const miniData = {
        songId,
        usuarioId: uid,
        taskId: null,
        shareLang: "",

        coverUrl: "",
        coverUrl02: "",
        videoUrl: "",
        videoUrl02: "",

        status: STATUS_OPTIONS.includes(status) ? status : "pending",
        titulo: safeStr(titulo).trim() || null,
        nombreCliente: safeStr(nombreCliente).trim() || null,

        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      await setDoc(miniRef, miniData, { merge: true });

      notifySongUpdate(uid);

      setMsg("Creada ✅ redirigiendo…");

      // ✅ llevarlo a la pantalla que ya tienes (editar por songId)
     // navigate(`/crearcancionweb/${songId}`);
    } catch (e) {
      console.error(e);
      setMsg("Error creando: " + (e?.message || "desconocido"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="ccw-top">
          <div>
            <h1 className="h1">Crear canción (desde usuario)</h1>
            <p className="p-muted" style={{ marginTop: 6 }}>
              Se creará un <strong>songId</strong> nuevo para:{" "}
              <strong className="mono">usuarios/{uid || "—"}/canciones</strong>
            </p>
          </div>

          <div className="ccw-actions">
            <button className="btn" onClick={() => navigate(-1)}>
              Volver
            </button>
            <button className="btn btn-primary" onClick={handleCreate} disabled={disabledCreate}>
              {saving ? "Creando…" : "Crear"}
            </button>
          </div>
        </div>

        {msg ? <div className="ccw-msg">{msg}</div> : null}

        <div className="card ccw-card">
          <div className="ccw-sectionTitle">Datos</div>
          <div className="ccw-grid">
            <div className="ccw-field">
              <div className="ccw-label">usuarioId</div>
              <div className="ccw-value mono">{uid || "—"}</div>
            </div>
          </div>
        </div>

        <div className="card ccw-card">
          <div className="ccw-sectionTitle">Editar</div>

          <div className="ccw-form">
            <div className="ccw-row">
              <label className="ccw-label2">Nombre cliente (opcional)</label>
              <input className="ccw-input" value={nombreCliente} onChange={(e) => setNombreCliente(e.target.value)} />
            </div>

            <div className="ccw-row">
              <label className="ccw-label2">Título</label>
              <input className="ccw-input" value={titulo} onChange={(e) => setTitulo(e.target.value)} />
            </div>

            <div className="ccw-row">
              <label className="ccw-label2">Estilo</label>
              <input className="ccw-input" value={estilo} onChange={(e) => setEstilo(e.target.value)} />
            </div>

            <div className="ccw-row">
              <label className="ccw-label2">Prompt</label>
              <textarea className="ccw-textarea" rows={3} value={prompt} onChange={(e) => setPrompt(e.target.value)} />
            </div>

            <div className="ccw-row">
              <label className="ccw-label2">Letra</label>
              <textarea className="ccw-textarea" rows={10} value={letra} onChange={(e) => setLetra(e.target.value)} />
            </div>

            <div className="ccw-split">
              <div className="ccw-row">
                <label className="ccw-label2">Status</label>
                <select className="ccw-input" value={status} onChange={(e) => setStatus(e.target.value)}>
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <div className="ccw-row ccw-checkRow">
                <label className="ccw-label2">Pago</label>
                <label className="ccw-check">
                  <input type="checkbox" checked={pago} onChange={(e) => setPago(e.target.checked)} />
                  <span>Pagado</span>
                </label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
